import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  trackEnabled: {
    backgroundColor: '#016AD4 !important'
  }
}))
